var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1447,
    transform: "translate(-418 -443)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -40.0605,
    y: -335.849,
    width: 1473.63,
    height: 1189.18,
    rx: 10,
    fill: "#F5F6FE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.238281,
    y: 0.065918,
    width: 653.655,
    height: 44,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.238281 5.06592C0.238281 2.30449 2.47686 0.065918 5.23828 0.065918H44.2383V44.0659H5.23828C2.47686 44.0659 0.238281 41.8273 0.238281 39.0659V5.06592Z",
    fill: "#454FDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2383 11.0659V33.0659",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2383 15.0659H19.7383C18.81 15.0659 17.9198 15.4347 17.2634 16.091C16.607 16.7474 16.2383 17.6377 16.2383 18.5659C16.2383 19.4942 16.607 20.3844 17.2634 21.0408C17.9198 21.6972 18.81 22.0659 19.7383 22.0659H24.7383C25.6665 22.0659 26.5568 22.4347 27.2132 23.091C27.8695 23.7474 28.2383 24.6377 28.2383 25.5659C28.2383 26.4942 27.8695 27.3844 27.2132 28.0408C26.5568 28.6972 25.6665 29.0659 24.7383 29.0659H16.2383",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollarIcon.bc57ab603a2a12ab1b60caa99df25a9c.svg";
export { ForwardRef as ReactComponent };